export const RECAPTCHA_SITE_KEY = "6Ld8jzQgAAAAAIBUNGuHeH1NUakY1DHYZo2SenBY"
